var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStarIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 57,
    viewBox: "0 0 57 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.34 0C12.68 0 0 12.68 0 28.34C0 44 12.68 56.68 28.34 56.68C44 56.68 56.68 44 56.68 28.34C56.83 12.68 44.01 0 28.34 0ZM43.85 25.51L38.03 30.88C37.73 31.18 37.58 31.63 37.58 32.07L39.22 39.83C39.67 41.62 37.58 43.11 35.94 42.22L29.08 38.34C28.63 38.04 28.19 38.04 27.74 38.34L20.88 42.22C19.24 43.11 17.3 41.77 17.6 39.83L19.24 32.07C19.39 31.62 19.24 31.18 18.79 30.88L12.97 25.51C11.63 24.17 12.37 21.93 14.16 21.63L22.07 20.74C22.52 20.74 22.96 20.44 23.11 19.99L26.39 12.83C27.14 11.04 29.67 11.04 30.42 12.83L33.7 19.99C33.85 20.44 34.3 20.74 34.74 20.74L42.65 21.63C44.44 21.93 45.18 24.32 43.84 25.51H43.85Z",
    fill: "#00ADEE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarIcon);
export default __webpack_public_path__ + "static/media/star-icon.7e1864e1ce4e514146fe4123f6b366fe.svg";
export { ForwardRef as ReactComponent };